<mat-card>
    <mat-card-header>
      <mat-card-title>Other Family Members</mat-card-title>
    </mat-card-header>
<mat-card-content class="m-t-1">
    <div class="family-container">
        <app-family-members #familyMembers
            [model]="model" 
            [formTypes]="formTypes" 
            [titles]="titles"
            [relationTypes]="relationTypes" 
            [maritalStatuses]="maritalStatuses"
            [educationLevels]="educationLevels"
            [countries]="countries"
            [visaTypes]="visaTypes"
            [applicantText]="applicantText"
            [selectedForm]="selectedForm"
            [isVevo]="isVevo"
            [isVevoEmployee]="isVevoEmployee"
            (formReady)="formReady.emit($event)"
            [submitAttempted]="submitAttempted">
        </app-family-members>
        
        <app-non-included-children  #nonIncludedChildren
            [model]="model" 
            [formTypes]="formTypes" 
            [titles]="titles"
            [relationTypes]="relationTypes" 
            [maritalStatuses]="maritalStatuses"
            [educationLevels]="educationLevels"
            [countries]="countries"
            [visaTypes]="visaTypes"
            [applicantText]="applicantText"
            [selectedForm]="selectedForm"
            [isVevo]="isVevo"
            [isVevoEmployee]="isVevoEmployee"
            (formReady)="formReady.emit($event)"
            [submitAttempted]="submitAttempted">
        </app-non-included-children>
    </div>
</mat-card-content>


</mat-card>

